import { render, staticRenderFns } from "./file-memory.vue?vue&type=template&id=34bb83a2&scoped=true&"
import script from "./file-memory.vue?vue&type=script&lang=js&"
export * from "./file-memory.vue?vue&type=script&lang=js&"
import style0 from "./file-memory.vue?vue&type=style&index=0&id=34bb83a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bb83a2",
  null
  
)

export default component.exports